<template>
  <div>
    <div class="row">
      <div class="col-4">
        <span>Calificación:</span>
      </div>
      <div class="col-4">
        <span>Fecha de Informe de Presunta Responsabilidad:</span>
      </div>
      <div class="col-4">
        <span>Devolución para Reclasificación:</span>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <select class="form-control" name="tipoDeCalificacionId" v-model="denuncia.tipoDeCalificacionId">
          <option value="-1">Seleccione la calificación</option>
          <option value="1">Grave</option>
          <option value="2">No Grave</option>
          <option value="3">Improcedente</option>
        </select>
      </div>
      <div class="col-4">
        <input type="date" class="form-control" name="fechaDeInforme" v-model="denuncia.fechaDeInforme"/>
      </div>
      <div class="col-4">
        <input type="date" class="form-control" name="fechaDeDevolucion" v-model="denuncia.fechaDeDevolucion"/>
      </div>
    </div>
    <div class="row new-row">
      <div class="col-9"></div>
      <div class="col-3">
        <input type="button" value="Guardar Datos Finales" class="form-control" @click="registrarDatosFinalesDenuncia" />
      </div>
    </div>

  </div>
</template>
<script>import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  import { Denuncia } from "@/components/SIFA/Comun/Modelos/Denuncia.js"
  export default {
    data() {
      return {
        denuncia: new Denuncia()
      }
    },
    props: {
      prop_denunciaId: Number,
      prop_denuncia: Denuncia
    },
    components: {

    },
    methods: {
      registrarDatosFinalesDenuncia: function () {
      //Retorna una lista de citas 'Aceptadas'
      this.denuncia.cargarDatosParaFormulario(["insertar-datos-finales"]);
      var peticion = {
        denuncia: this.denuncia,
      };
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SIFA.funciones.RegistrarDatosFinalesDenuncia,
          peticion /*, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)*/
        )
        .then((response) => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {
            //En caso de que la petición sea exitosa
            comun.mensajeDeAlerta(
              `${response.data.Satisfactorio}`,
              null,
              null
            );
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },

    }, mounted: function mounted() {
      if(this.prop_denunciaId){
      this.denuncia.denunciaId = this.prop_denunciaId;
      this.denuncia.cargarDatosParaFormulario(["datos-finales"]);
      }
      if(this.prop_denuncia.denunciaId){
      this.denuncia = this.prop_denuncia
      if(!this.denuncia.tipoDeCalificacionId){
        this.denuncia.tipoDeCalificacionId = -1;
      }
      }
      
    },
    computed: {
      datosFinalesNoValidos() {        
        return false
      }

    }
  }</script>

<style scoped>
  span {
    font-weight: bold;
  }

  b {
    padding-right: 3px;
  }

  .new-row {
    margin-top: 20px;
  }

  .bigtextarea {
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SIFA/AtencionDenuncias/RegistroDeDenuncia/DatosFinales.vue